module.exports = __webpack_public_path__ + "static/media/basicos_checked.f2c1e884.svg";